import React from 'react';

const TermsOfServicePage: React.FC = () => {
  return (
    <div className="py-12 px-4 sm:px-6 lg:px-8 font-sans flex-1">
      <div className="max-w-3xl mx-auto p-8 sm:p-12">
        <h1 className="text-3xl font-bold mb-6 text-gray-900 tracking-tight">Terms of Service</h1>
        <p className="text-sm text-gray-500 mb-8 font-medium">Last updated: {new Date().toLocaleDateString()}</p>
        
        <div className="space-y-8 text-gray-600 leading-relaxed">
          <section>
            <h2 className="text-xl font-semibold mb-3 text-gray-900 tracking-wide">1. Acceptance of Terms</h2>
            <p>By accessing and using our automated messaging services, you accept and agree to be bound by the terms and provision of this agreement. If you do not agree to abide by these terms, please do not use this service.</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3 text-gray-900 tracking-wide">2. Description of Service</h2>
            <p>Our platform provides AI-driven automated responses for business messaging accounts on platforms like Instagram and WhatsApp. We act as a data processor facilitating communication between businesses and their customers.</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3 text-gray-900 tracking-wide">2. Use License</h2>
            <p>
              Permission is granted to temporarily download one copy of the materials (information or software) on our website for personal, non-commercial transitory viewing only.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3 text-gray-900 tracking-wide">3. User Conduct</h2>
            <p>You agree to use the service only for lawful purposes. You are prohibited from using the service to send spam, abusive, or otherwise inappropriate content. We reserve the right to terminate access for users who violate these terms.</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3 text-gray-900 tracking-wide">4. Third-Party Platforms</h2>
            <p>Our service integrates with third-party platforms (e.g., Meta). Your use of those platforms is also governed by their respective Terms of Service and Privacy Policies. We are not responsible for the availability or functionality of these third-party services.</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3 text-gray-900 tracking-wide">5. Limitation of Liability</h2>
            <p>We shall not be liable for any indirect, incidental, special, consequential, or punitive damages resulting from your use of or inability to use the service, including but not limited to any AI-generated responses that may be inaccurate or inappropriate.</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3 text-gray-900 tracking-wide">6. Modifications to Terms</h2>
            <p>We reserve the right to modify these terms at any time. We will do our best to provide notice of any significant changes. Your continued use of the service following the posting of changes constitutes your acceptance of such changes.</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3 text-gray-900 tracking-wide">7. Contact Us</h2>
            <p>
              If you have any questions about these Terms, please contact us at: <a href="mailto:contacto@taratic.com" className="text-blue-600 hover:text-blue-500 underline underline-offset-2">contacto@taratic.com</a>
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default TermsOfServicePage;
